import { useDispatch } from "react-redux";
import { Box, Button, List, ListItem, Typography } from "@mui/material";
import asset from "json/assets";
import React, { useEffect, useState } from "react";
import styles from "styles/component/CustomCoursePopOver.module.scss";

import eventEmitter from "services/event.emitter";
import events from "json/events";
import Draggable from "react-draggable";
import CourseMapOptionListTable from "components/CourseMapOptionListTable/CourseMapOptionListTable";
import FacilityHazardFeatures from "components/FacilityHazardFeatures/FacilityHazardFeatures";
import FacilityFeatures from "components/FacilityFeatures/FacilityFeatures";
import {
  useEditableCourseItem,
  useIsDrawingStatus,
  useSelectedCourseZoneType,
} from "hooks/CourseMapDetails";
import { courseMapElementLimit } from "json/constants";
import useNotiStack from "hooks/useNotistack";
import * as _ from "underscore";
import { setSelectedGroup } from "redux/MapSlice";
import { clearSelectedCourseZoneType } from "redux/CourseMapSlice";
import { getScreenMeasurement } from "services/utils";
import { useRefHook } from "hooks/useRefHook";
const DraggableCoursePopOver = (props) => {
  const {
    title = "Course Info",
    data,
    cancelEdit,
    hazardData,
    fcbData,
    teeCenterData,
    courseWiseData,
    clubHouseCenterData,
    setMapControlListPanelHidden
  } = props;
  const dispatch = useDispatch();
  const singleElementTypeZones = [
    "Perimeter",
    "Green",
    "Centralpath",
    "Clubhousecenter",
  ];
  const { toastWarning } = useNotiStack();
  const isDrawing = useIsDrawingStatus();

  const zoneType = useSelectedCourseZoneType();
  const editableArea = useEditableCourseItem();
  const [open, setOpen] = useState(false);
  const [mCooords, setMCoords] = useState(null);
  const [selectedHoleFeature, setHoleFeature] = useState("Teebox");
  const [selectedFacilityHazard, setFacilityHazard] = useState("Tree");
  const [selectedFacilityFeature, setFacilityFeature] = useState("Background");

  useEffect(() => {
    const handler = (e) => {
      if (e?.title === title) {
        setOpen(e.visible);
        if (e.visible) setMCoords(e.mCoord);
      } else {
        if (e?.visible) {
          setHoleFeature("Teebox");
          setFacilityHazard("Tree");
          setFacilityFeature("Background");
          setOpen(false);
        }
      }
    };

    eventEmitter.on(events.openMapElementInfoModal, handler);
    return () => eventEmitter.off(events.openMapElementInfoModal, handler);
  }, [title]);

  const handleClose = () => {
    setHoleFeature("Teebox");
    setFacilityHazard("Tree");
    setFacilityFeature("Background");
    setOpen(false);
    setMapControlListPanelHidden(false);
    dispatch(setSelectedGroup(""));
    // dispatch(setEditableArea(""));s
    dispatch(clearSelectedCourseZoneType());

    eventEmitter.emit(events.disableDraw);

    // turning off opened modal when closing popup, else it glitches.
    eventEmitter.emit(events.addMarkerToggle, { visible: false });
  };

  eventEmitter.on(events.openMapElementInfoModal, (e) => {
    if (title === e?.title) {
      setOpen(e.visible);
      setMCoords(e.mCoord);
    } else {
      setOpen(false);
      //   setMCoords(null);
    }
  });
  const emitDrawPolygon = () => {
    let z = zoneType?.type;
    if (zoneType?.type === "line") {
      z = "polyline";
    }
    eventEmitter.emit(events.draw, { event: "add", type: z });

    //filter by selected zone type : polygon,marker,polyline etc.
    // eventEmitter.emit(events.draw, { event: "add", type: "polygon" });
  };
  const addHoleFeatures = () => {
    // if (_.isEmpty(editableArea)) {
    let limit = courseMapElementLimit[`${zoneType?.element?.toLowerCase()}`];

    if (singleElementTypeZones.includes(zoneType?.element)) {
      if (zoneType?.data && zoneType?.data?.length === 1) {
        toastWarning(`You can not add more than one ${zoneType?.element}`);
        return;
      }
    } else if (zoneType?.element === "Teebox") {
      if (zoneType?.data && zoneType?.data?.length === limit) {
        toastWarning(`You cannot add more than ${limit} ${zoneType?.element}.`);
        return;
      }
    }
    //------------------------------------------
    else if (zoneType?.element === "fcb") {
      if (
        zoneType?.data &&
        zoneType?.data?.length ===
          courseMapElementLimit[`${zoneType?.element?.toLowerCase()}`]
      ) {
        toastWarning(`Front, Center & Back is already added for this hole.`);
        return;
      }
    } else if (zoneType?.element === "Teeboxcenter") {
      if (zoneType?.data && zoneType?.data?.length === limit) {
        toastWarning(`You cannot add more than ${limit} ${zoneType?.element}.`);
        return;
      }
    } else if (zoneType?.element === "Hazard") {
      if (zoneType?.data && zoneType?.data?.length === limit) {
        toastWarning(`You cannot add more than ${limit} ${zoneType?.element}.`);
        return;
      }
    }

    emitDrawPolygon();
    // } else {
    //   toastWarning("Can not add shape in edit mode.");
    // }
  };
  const singularFacilityElements = ["background", "clubhouse"];
  const addFacilityFeatures = () => {
    if (singularFacilityElements.includes(zoneType?.element.toLowerCase())) {
      if (zoneType?.data && zoneType?.data?.length === 1) {
        toastWarning(`You can not add more than one ${zoneType?.element}`);
        return;
      }
    }
    emitDrawPolygon();
  };
   const editableAreaRef = useRefHook(editableArea);
  const handleClick = (e) => {
    if (isDrawing) {
      toastWarning(`Already in Draw mode`);
      return;
    }
    if (_.isEmpty(editableArea)) {
      if (zoneType?.hole !== -1) {
       if(zoneType?.element ===  'Bunker' && editableAreaRef?.current?.label !== "Bunker"){
        eventEmitter.emit(events.openBunkerElementInModal, { open: true });

          }else{
             addHoleFeatures();
          }


      } else if(zoneType?.element === "Tree" && editableAreaRef?.current?.label !== "Tree"){
        eventEmitter.emit(events.openTreeElementInModal, { open: true });

          }
          
          else{
        addFacilityFeatures();
      }
    } else {
      toastWarning("Can not add shape in edit mode.");
    }
  };

  

  const hidePanel = () => {
    setMapControlListPanelHidden(true);
    setOpen(false);
  }  
  const getListComponent = (title) => {
    if (title === "Hole Features") {
      return (
        <CourseMapOptionListTable
          element={selectedHoleFeature}
          setElement={setHoleFeature}
          contentData={data}
          cancelEdit={cancelEdit}
          hazardData={hazardData}
          fcbData={fcbData}
          teeCenterData={teeCenterData}
        />
      );
    } else if (title === "Facility Hazard Features") {
      return (
        <FacilityHazardFeatures 
          element={selectedFacilityHazard} 
          setElement={setFacilityHazard} 
          courseWiseData={courseWiseData} 
        />
    );
    } else if (title === "Facility") {
      // return <>Facility Features will come here </>;
      return (
        <FacilityFeatures
          courseWiseData={courseWiseData}
          clubHouseCenterData={clubHouseCenterData}
          element={selectedFacilityFeature}
          setElement={setFacilityFeature}
        />
      );
    }
  };
  return (
    // <Box className={`${styles.sub_popover} ${styles.draggableDiv}`}>
    <>
      {open ? (
        <>
          {" "}
          {mCooords?.x && mCooords?.y ? (
            <>
              <Draggable
                bounds={"#DraggableContainer"}
                // defaultPosition={{ x: 0, y: 0 }}
                defaultPosition={{
                  x: mCooords.x - 530,
                  y: 0,
                }}
                // key={Math.random()} //  resets the dragged modal to initial position on load ~ new key=> new DOM change
              >
                {/* ${styles.course_elem_popover} ${title==='Facility'? `${styles.no_width_course_elem_popover}`:styles.course_elem_popover} */}
                <Box
                  className={`${styles.poover_content} ${styles.default_poover_content} custom_popover_content`}
                  sx={{
                    opacity: open ? "1" : "0",
                    display: open ? "block" : "none",
                    top: "10px !important",
                  }}
                >
                  <Box className={styles.poover_head}>
                    <Typography variant="h5">{title}</Typography>
                    <List>
                      <ListItem>
                        <Button 
                          className={styles.arrow_btn}
                          onClick={hidePanel}
                        >
                          <img src={asset.right_arrow_white} alt="" />
                        </Button>
                      </ListItem>
                      <ListItem>
                        <Button
                          onClick={handleClick}
                          // aria-describedby={idNew}
                          // disabled={addShapeDisabled}
                        >
                          <img src={asset.plus} alt="" />
                        </Button>
                      </ListItem>
                      <ListItem>
                        <Button
                          //   aria-describedby={id}
                          onClick={handleClose}
                        >
                          <img src={asset.close} alt="" />
                        </Button>
                      </ListItem>
                    </List>
                  </Box>
                  <Box className={styles.popover_body}>
                    {getListComponent(title)}
                  </Box>
                </Box>
              </Draggable>
            </>
          ) : null}
        </>
      ) : null}
    </>
    // </Box>
  );
};

export default DraggableCoursePopOver;
